<template>
  <div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="create_time"
		      label="评论时间"
		      align="center"
		      width="160"
        >
		    </el-table-column>
		    <el-table-column
		      prop="user_name"
		      label="用户名称"
		      align="center"
		      width="120"
        >
		    </el-table-column>
		    <el-table-column
		      prop="server_name"
		      label="评论项目"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="comment"
		      label="评论文字"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="评论图片"
		      align="center"
        >
          <template slot-scope="scope">
            <viewer :images="scope.row.comment_img" v-if="scope.row.comment_img">
             <img :src="imgDomain + item"  class="project-img" v-for="item of scope.row.comment_img" :key="item">
            </viewer>
            <div v-else>-</div>
          </template>
		    </el-table-column>
		    <el-table-column
		      label="评论星级"
		      align="center"
        >
          <template slot-scope="scope">
          	<i v-for="item in scope.row.star" :key="item" class="iconfont">&#xe629;</i>
          </template>
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="120"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="commentHandleClick(scope.row, 'show')" v-if="auth_control.have_show_auth && scope.row.is_read ==='2'">展示</span>
         	    <span class="opration-item" @click="commentHandleClick(scope.row, 'hide')" v-if="auth_control.have_hide_auth && scope.row.is_read ==='1'">隐藏</span>
         	    <span class="opration-item" @click="deleteServiceClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
	    :total="total"
      :page_size="page_size"
	    @size-change="handelPagesizeChange"
	    @page-change="handlePageChange"
	  ></common-pagination>
    </div>
    <common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap" v-if="handel_type === 'show'">
  		   是否要展示该条评论？
      </div>
      <div class="dialog-body-wrap" v-if="handel_type === 'hide'">
  		   是否要隐藏该条评论？
      </div>
      <div class="dialog-body-wrap" v-if="handel_type === 'delete'">
  		   是否要删除该条评论？
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { commentList, commentHandle, commentDelete } from '@/api/content-manage';
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';
import { mapState } from 'vuex';

export default {
  name: 'commentmanage',
  data() {
  	return {
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  		tableData: [],
  		dialogTitle: '',
  		dialogVisible: false,
  		handle_row: {},
  		handel_type: '', //显示还是隐藏
  		dialogTitle: '',
      auth_control: {
        have_show_auth: false,
        have_hide_auth: false,
        have_delete_auth: false,
      },
      three_rules: [],
  	}
  },
  computed: {
    ...mapState(['imgDomain', 'operationList'])
  },
  components: {
    CommonDialog,
    CommonPagination
  },
  mounted() {
     this.getCommentList();
     this.handleThreeRules();
  },
  methods: {
  	async getCommentList() {
      let postData = {
      	page_index: this.page_index,
      	page_size: this.page_size
      };
      const { data, status } = await commentList(postData);
      if ( status !== 200 ) return
      this.total = data.total;
      this.tableData = data.data;
      console.log(data, 'comment list')
  	},
  	handelPagesizeChange(size) {
  		this.page_size = size;
  		this.getCommentList();
  	},
  	handlePageChange(page) {
  		this.page_index = page;
  		this.getCommentList();
  	},
  	commentHandleClick(row, type) {
  		this.handle_row = row;
  		this.handel_type = type;
  		this.dialogTitle = '展示/隐藏评论'
  		this.dialogVisible = true;
  	},
  	deleteServiceClick (row) {
      this.handel_type = 'delete';
      this.handle_row = row;
      this.dialogTitle = '删除评论';
      this.dialogVisible = true;
  	},
   	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
  		if (this.handel_type === 'show' || this.handel_type === 'hide') {
	      const { status } = await commentHandle(this.handle_row.uuid);
	      if (status !== 200 ) return
	      this.dialogVisible = false;
	    }
	    if (this.handel_type === 'delete') {
        const { status } = await commentDelete(this.handle_row.uuid);
        if (status !== 200 ) return
	      this.dialogVisible = false;
	    }
  	},
  	dialogClose() {
      this.getCommentList();
      this.dialogVisible = false;
  	},
    handleThreeRules() {
      console.log(this.operationList, 'oper list')
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf('隐藏') !== -1:
            this.auth_control.have_hide_auth = true;
            break;
          case item.menu_name.indexOf('显示') !== -1:
            this.auth_control.have_show_auth = true;
            break;
          case item.menu_name.indexOf('删除') !== -1:
            this.auth_control.have_delete_auth = true;
            break;
        }
      })
     console.log(this.three_rules, 'three rules comment')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.table-wrap {
	margin-top: 40px;
	.operation-wrap {
		display: flex;
		justify-content: space-around;
		color: @color-text;
		.opration-item{
			cursor: pointer;
		}
  }
  .project-img {
    height: 300px;
  }
}
.dialog-body-wrap {
	text-align: center;
}
</style>
